import { SettingsRoutesEnum } from './routes.enum';

export const settingsTabs = [
  {
    label: 'Profile',
    value: SettingsRoutesEnum.Profile,
  },
  {
    label: 'Organization',
    value: SettingsRoutesEnum.Organization,
  },
  {
    label: 'Billing',
    value: SettingsRoutesEnum.Billing,
  },
];
